import React from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import withStyles from '@material-ui/core/styles/withStyles'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import compose from 'recompose/compose'
// import InputSuggestions from 'components/InputSuggestions'
import regexp from 'utils/regexp'

const styles = (theme) => ({
  form: {},
  input: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8em',
    },
  },
  workoutNameInput: {
    color: '#000',
    '&:hover': {
      cursor: 'text',
    },
  },
  label: {
    color: theme.palette.primary.main,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      fontSize: '0.8em',
      bottom: 3,
    },
  },
  helperText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7em',
    },
  },
  submitBtn: {
    margin: '0 2px',
    fontWeight: 300,
    color: '#fff',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.8em',
    },
  },
  newWorkoutBtn: {
    padding: 0,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.6em',
    },
  },
})

const renderTextField = ({
  input,
  meta: { touched, error },
  ...customProps
}) => <TextField error={touched && !!error} {...input} {...customProps} />

class SubmitMentionForm extends React.Component {
  state = { existing: true }

  onExistingChange = () => this.setState({ existing: !this.state.existing })

  render() {
    const { classes, workoutSuggestions, handleSubmit, submitting } = this.props
    const { state } = this
    return (
      <form
        method="post"
        name="submit_mention_form"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        onSubmit={handleSubmit}
        className={classes.form}
        style={{ opacity: submitting ? 0.4 : 1 }}
      >
        <input type="hidden" name="form-name" value="submit_mention_form" />
        {/* {state.existing && (
          <Field
            name="workout"
            label="Workout name"
            component={InputSuggestions}
            workoutSuggestions={workoutSuggestions}
            InputLabelProps={{ className: classes.label }}
            required
            fullWidth
          />
        )} */}
        <Field
          InputLabelProps={{ className: classes.label }}
          name="workout"
          label="Workout Name"
          component={renderTextField}
          required
          fullWidth
        />

        {/* <Button
          onClick={this.onExistingChange}
          size="small"
          color={state.existing ? 'primary' : 'secondary'}
          className={classes.newWorkoutBtn}
        >
          {state.existing
            ? 'Click here if submitting a new workout'
            : 'Click here if submitting a current workout'}
        </Button> */}
        <Field
          InputProps={{ className: classes.input }}
          InputLabelProps={{ className: classes.label }}
          FormHelperTextProps={{ className: classes.helperText }}
          name="url"
          label="What is the URL to the source?"
          helperText="A mention needs a URL to direct the user to."
          component={renderTextField}
          required
          fullWidth
        />
        <Field
          InputProps={{ className: classes.input }}
          InputLabelProps={{ className: classes.label }}
          FormHelperTextProps={{ className: classes.helperText }}
          name="creditsTo"
          label="Who should we give credits to for this submission? (Optional)"
          helperText="You can type a person's name, a website link to a homepage, or an email address."
          component={renderTextField}
          fullWidth
        />
        <Field
          InputProps={{ className: classes.input }}
          InputLabelProps={{ className: classes.label }}
          FormHelperTextProps={{ className: classes.helperText }}
          name="email"
          label="Email address (Optional)"
          helperText="Note that we might need a way to communicate if there are any issues to address."
          component={renderTextField}
          fullWidth
        />
        <div style={{ padding: '20px 0' }}>
          <Button
            className={classes.button}
            color="primary"
            type="submit"
            variant="raised"
          >
            Submit
          </Button>
        </div>
      </form>
    )
  }
}

SubmitMentionForm.propTypes = {
  classes: PropTypes.object.isRequired,
  workoutSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
}

// prettier-ignore
export default compose(
  reduxForm({ form: 'submit_mention_form',
  validate: ({ workout, url, email }) => {
    const errors = {}
    if (!workout) {
      errors.workout = 'Please provide a workout name!'
    }
    if (!url) {
      errors.url = 'A mention needs a URL to direct the user to!'
    }
    if (email && !regexp.email.test(email)) {
      errors.email = 'Please provide a valid email.'
    }
    return errors
  },
 }),
  withStyles(styles),
)(SubmitMentionForm)



// WEBPACK FOOTER //
// ./src/components/forms/SubmitMentionForm.js